// extracted by mini-css-extract-plugin
export default {"container":"ModalCloseButton--container--9e0a1f"};